import { render, staticRenderFns } from "./altaImpagoCancelada.vue?vue&type=template&id=2f0546d4&scoped=true&"
import script from "./altaImpagoCancelada.vue?vue&type=script&lang=js&"
export * from "./altaImpagoCancelada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0546d4",
  null
  
)

export default component.exports